import React from 'react';

import Navigator from './navigation';

const App = () => {
  return <Navigator />;
};

export default App;
